import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import config from "../../config";
import { toast } from "react-toastify";
import iphoneHero from "../../assets/landing/uae-1.jpg";

const SunIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="4"/>
    <path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M4.93 19.07l1.41-1.41M17.66 6.34l1.41-1.41"/>
  </svg>
);

const MoonIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16" fill="currentColor" stroke="none">
    <path d="M12 3a6 6 0 0 0 9 9 9 9 0 1 1-9-9z"/>
  </svg>
);

const CheckIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="10" cy="10" r="10" fill="#10b981" />
    <path d="M6 10.2L8.7 13L14.2 7.5" stroke="#FFFFFF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export function LandingComingSoon({ theme, toggleTheme, user, onSwitchToLive, onPreviewLive }) {
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    try {
      if (localStorage.getItem("hs_vip_subscribed") === "true") {
        setSubmitted(true);
      }
    } catch (_) {}
  }, []);

  const isDark = theme === "dark";

  // Palette tokens
  const colors = {
    bg: isDark ? "#08090C" : "#F8FAFC",
    surface: isDark ? "rgba(255, 255, 255, 0.05)" : "#FFFFFF",
    surfaceBorder: isDark ? "rgba(255, 255, 255, 0.08)" : "rgba(0, 0, 0, 0.08)",
    cardBg: isDark ? "rgba(18, 20, 29, 0.75)" : "rgba(255, 255, 255, 0.95)",
    textDark: isDark ? "#FFFFFF" : "#0F172A",
    textMuted: isDark ? "#94A3B8" : "#64748B",
    primary: "#0284c7",
    primaryHover: "#0369a1",
    accentGlow: isDark ? "rgba(2, 132, 199, 0.25)" : "rgba(2, 132, 199, 0.15)",
    inputInnerBorder: isDark ? "rgba(255, 255, 255, 0.12)" : "rgba(0, 0, 0, 0.1)",
    inputBg: isDark ? "rgba(0, 0, 0, 0.25)" : "#F1F5F9",
  };

  const handleNotifySubmit = async (e) => {
    e.preventDefault();
    const cleanEmail = email.trim();
    if (!cleanEmail || !cleanEmail.includes("@")) {
      toast.error("Please enter a valid email address");
      return;
    }

    setLoading(true);

    try {
      // 1. Primary: dedicated early-access subscription endpoint
      const res = await fetch(`${config.API_BASE_URL}/api/settings/early-access`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: cleanEmail }),
      });

      if (!res.ok) {
        // Fallback: contact endpoint
        await fetch(`${config.API_BASE_URL}/api/contact`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            name: "VIP Early Access Subscriber",
            email: cleanEmail,
            phone: "+971000000000",
            message: `VIP Early Access subscription: ${cleanEmail}`,
          }),
        });
      }

      setSubmitted(true);
      try {
        localStorage.setItem("hs_vip_subscribed", "true");
      } catch (_) {}
      toast.success("Thank you! You are on our VIP early access list.");
    } catch {
      // Graceful local acceptance if offline or network hiccup
      setSubmitted(true);
      try {
        localStorage.setItem("hs_vip_subscribed", "true");
      } catch (_) {}
      toast.success("Thank you! You are on our VIP early access list.");
    } finally {
      setLoading(false);
    }
  };

  const isAdmin = user && (user.role === "admin" || (user.permissions && user.permissions.includes("admin_access")));

  return (
    <div
      className={`hs-landing ${isDark ? "" : "lp-light-theme"}`}
      style={{
        minHeight: "100vh",
        backgroundColor: colors.bg,
        color: colors.textDark,
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        fontFamily: "'Outfit', -apple-system, BlinkMacSystemFont, sans-serif",
        overflowX: "hidden",
        position: "relative",
      }}
    >
      {/* Responsive Styles for Form & Mobile Preview */}
      <style>{`
        .hs-cs-form-wrap {
          display: flex;
          align-items: center;
          gap: 0.5rem;
          padding: 0.4rem;
          border-radius: 9999px;
          background-color: ${colors.surface};
          border: 1px solid ${colors.surfaceBorder};
          box-shadow: ${isDark ? "0 4px 20px rgba(0, 0, 0, 0.4)" : "0 4px 20px rgba(0, 0, 0, 0.05)"};
          max-width: 500px;
          width: 100%;
          box-sizing: border-box;
          transition: all 0.2s ease;
        }

        .hs-cs-input {
          flex: 1;
          min-width: 0;
          background: transparent;
          border: none;
          outline: none;
          padding: 0.65rem 1.1rem;
          font-size: 0.95rem;
          color: ${colors.textDark};
          font-family: 'Outfit', sans-serif;
          box-sizing: border-box;
        }

        .hs-cs-btn {
          padding: 0.7rem 1.4rem;
          border-radius: 9999px;
          background-color: ${colors.primary};
          color: #ffffff;
          border: none;
          font-weight: 500;
          font-size: 0.9rem;
          cursor: pointer;
          white-space: nowrap;
          flex-shrink: 0;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          height: 42px;
          box-sizing: border-box;
          transition: background 0.2s ease, transform 0.1s ease;
        }

        .hs-cs-btn:hover {
          background-color: ${colors.primaryHover};
        }

        /* Mobile Viewport Breakpoint: Stack cleanly into a neat card */
        @media (max-width: 560px) {
          .hs-cs-form-wrap {
            flex-direction: column !important;
            align-items: stretch !important;
            border-radius: 18px !important;
            padding: 0.85rem !important;
            gap: 0.75rem !important;
            box-shadow: ${isDark ? "0 4px 24px rgba(0, 0, 0, 0.5)" : "0 4px 16px rgba(0, 0, 0, 0.06)"} !important;
          }

          .hs-cs-input {
            width: 100% !important;
            padding: 0.8rem 1rem !important;
            border-radius: 12px !important;
            border: 1px solid ${colors.inputInnerBorder} !important;
            background: ${colors.inputBg} !important;
            text-align: center !important;
            font-size: 0.92rem !important;
          }

          .hs-cs-btn {
            width: 100% !important;
            border-radius: 12px !important;
            height: 46px !important;
            font-size: 0.95rem !important;
            font-weight: 600 !important;
          }
        }
      `}</style>

      {/* Background radial glow */}
      <div
        aria-hidden
        style={{
          position: "absolute",
          top: "-150px",
          left: "50%",
          transform: "translateX(-50%)",
          width: "900px",
          height: "600px",
          borderRadius: "50%",
          background: `radial-gradient(ellipse at center, ${colors.accentGlow} 0%, transparent 70%)`,
          pointerEvents: "none",
          zIndex: 0,
        }}
      />

      {/* 1. Header / Navbar - Clean without any listing buttons */}
      <header
        style={{
          position: "sticky",
          top: 0,
          zIndex: 50,
          background: isDark ? "rgba(8, 9, 12, 0.85)" : "rgba(255, 255, 255, 0.9)",
          backdropFilter: "blur(16px)",
          borderBottom: `1px solid ${colors.surfaceBorder}`,
          padding: "1rem 1.5rem",
        }}
      >
        <div
          style={{
            maxWidth: "1200px",
            margin: "0 auto",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          {/* Logo */}
          <Link to="/" style={{ display: "flex", alignItems: "center", gap: "0.6rem", textDecoration: "none" }}>
            <img
              src="/assets/images/logo-light.png"
              alt="HubScroll"
              style={{ height: "2.4rem", display: "block" }}
              onError={(e) => { e.target.onerror = null; e.target.src = "/assets/images/logo.png"; }}
            />
            <span
              style={{
                background: "linear-gradient(270deg, #24c5f7 0%, #0388d6 100%)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                fontSize: "1.45rem",
                fontWeight: 700,
                letterSpacing: "-0.02em",
              }}
            >
              HubScroll
            </span>
          </Link>

          {/* Right: Only Modern Theme Toggle (no listing buttons) */}
          <button
            onClick={toggleTheme}
            aria-label="Toggle theme"
            title={isDark ? "Switch to Light Mode" : "Switch to Dark Mode"}
            style={{
              background: isDark ? "rgba(74, 158, 255, 0.15)" : "rgba(0, 0, 0, 0.05)",
              border: isDark ? "1px solid rgba(74, 158, 255, 0.3)" : "1px solid rgba(0, 0, 0, 0.1)",
              borderRadius: "9999px",
              cursor: "pointer",
              padding: "3px 6px",
              display: "inline-flex",
              alignItems: "center",
              gap: "4px",
              transition: "all 0.2s ease",
            }}
          >
            <span
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "22px",
                height: "22px",
                borderRadius: "50%",
                background: isDark ? "transparent" : "#fff",
                boxShadow: isDark ? "none" : "0 1px 3px rgba(0,0,0,0.15)",
                color: isDark ? "rgba(255,255,255,0.4)" : "#f59e0b",
              }}
            >
              <SunIcon />
            </span>
            <span
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "22px",
                height: "22px",
                borderRadius: "50%",
                background: isDark ? "#0284c7" : "transparent",
                boxShadow: isDark ? "0 0 8px rgba(2, 132, 199, 0.5)" : "none",
                color: isDark ? "#fff" : "rgba(0,0,0,0.3)",
              }}
            >
              <MoonIcon />
            </span>
          </button>
        </div>
      </header>

      {/* 2. Main Hero Showcase */}
      <main
        style={{
          position: "relative",
          zIndex: 10,
          flex: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "3.5rem 1.5rem",
        }}
      >
        <div
          style={{
            maxWidth: "1200px",
            width: "100%",
            margin: "0 auto",
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))",
            gap: "3.5rem",
            alignItems: "center",
          }}
        >
          {/* Left Column: Headline, Early Access Form, Clean Tags */}
          <div style={{ display: "flex", flexDirection: "column", gap: "1.75rem" }}>
            
            {/* Status Live Pulse Badge (no emojis) */}
            <div
              style={{
                alignSelf: "flex-start",
                display: "inline-flex",
                alignItems: "center",
                gap: "0.5rem",
                padding: "0.4rem 1rem",
                borderRadius: "9999px",
                backgroundColor: isDark ? "rgba(2, 132, 199, 0.12)" : "rgba(2, 132, 199, 0.08)",
                border: "1px solid rgba(2, 132, 199, 0.25)",
              }}
            >
              <span
                style={{
                  width: "8px",
                  height: "8px",
                  borderRadius: "50%",
                  backgroundColor: "#0284c7",
                  boxShadow: "0 0 10px #0284c7",
                  display: "inline-block",
                }}
              />
              <span
                style={{
                  fontSize: "0.78rem",
                  fontWeight: 600,
                  textTransform: "uppercase",
                  letterSpacing: "0.06em",
                  color: isDark ? "#38bdf8" : "#0284c7",
                }}
              >
                Under Maintenance &middot; Launching Soon in the UAE
              </span>
            </div>

            {/* Main Headline */}
            <h1
              style={{
                fontFamily: "'Fraunces', serif",
                fontSize: "clamp(2.3rem, 4.5vw, 3.8rem)",
                fontWeight: 600,
                lineHeight: 1.15,
                letterSpacing: "-0.025em",
                margin: 0,
                color: colors.textDark,
              }}
            >
              The UAE's Best Venues,
              <br />
              <span
                style={{
                  background: "linear-gradient(270deg, #24c5f7 0%, #0388d6 100%)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                  fontStyle: "italic",
                }}
              >
                One Scroll Away.
              </span>
            </h1>

            {/* Subtitle */}
            <p
              style={{
                fontSize: "1.08rem",
                lineHeight: 1.65,
                fontWeight: 300,
                color: colors.textMuted,
                margin: 0,
                maxWidth: "540px",
              }}
            >
              We are putting the finishing touches on HubScroll &mdash; Dubai and the UAE's premier mobile discovery app for cafés, restaurants, lounges, and nightlife destinations.
            </p>

            {/* VIP Notification Form Card - Fixed & Beautiful on Mobile */}
            <div style={{ maxWidth: "500px", width: "100%" }}>
              {!submitted ? (
                <form onSubmit={handleNotifySubmit} className="hs-cs-form-wrap">
                  <input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="Enter email for VIP early access..."
                    required
                    className="hs-cs-input"
                  />
                  <button
                    type="submit"
                    disabled={loading}
                    className="hs-cs-btn"
                  >
                    {loading ? "Joining..." : "Get Early Access"}
                  </button>
                </form>
              ) : (
                <div
                  style={{
                    padding: "1rem 1.4rem",
                    borderRadius: "1rem",
                    backgroundColor: isDark ? "rgba(16, 185, 129, 0.12)" : "rgba(16, 185, 129, 0.08)",
                    border: "1px solid rgba(16, 185, 129, 0.3)",
                    display: "flex",
                    alignItems: "center",
                    gap: "0.85rem",
                  }}
                >
                  <CheckIcon />
                  <div>
                    <div style={{ fontWeight: 600, color: "#10b981", fontSize: "0.95rem" }}>
                      You're on the VIP launch list!
                    </div>
                    <div style={{ fontSize: "0.82rem", color: colors.textMuted, marginTop: "0.15rem" }}>
                      We will notify you as soon as HubScroll opens in Dubai & the UAE.
                    </div>
                  </div>
                </div>
              )}
            </div>

            {/* Experience Pill Tags (clean typography, no emojis) */}
            <div style={{ display: "flex", flexWrap: "wrap", gap: "0.5rem" }}>
              {[
                "Trending Cafés",
                "Fine & Casual Dining",
                "Rooftops & Lounges",
                "Interactive UAE Map",
                "Exclusive Perks"
              ].map((tag, i) => (
                <span
                  key={i}
                  style={{
                    fontSize: "0.78rem",
                    fontWeight: 400,
                    padding: "0.4rem 0.85rem",
                    borderRadius: "9999px",
                    backgroundColor: colors.surface,
                    border: `1px solid ${colors.surfaceBorder}`,
                    color: colors.textMuted,
                    letterSpacing: "0.01em",
                  }}
                >
                  {tag}
                </span>
              ))}
            </div>

            {/* Partner / Business subtle note (NO listing buttons) */}
            <div
              style={{
                fontSize: "0.88rem",
                color: colors.textMuted,
                marginTop: "0.5rem",
                lineHeight: 1.5,
              }}
            >
              Are you a hospitality venue owner or partner?{" "}
              <Link
                to="/contact"
                style={{
                  color: colors.primary,
                  textDecoration: "underline",
                  fontWeight: 500,
                }}
              >
                Contact our launch team
              </Link>
            </div>

          </div>

          {/* Right Column: Visual iPhone App Mockup */}
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              position: "relative",
            }}
          >
            {/* Phone Backdrop glow */}
            <div
              style={{
                position: "absolute",
                width: "320px",
                height: "500px",
                borderRadius: "50%",
                background: "radial-gradient(ellipse at center, rgba(3, 136, 214, 0.28) 0%, transparent 70%)",
                zIndex: 0,
              }}
            />

            {/* Phone Mockup Frame */}
            <div
              style={{
                position: "relative",
                zIndex: 1,
                maxWidth: "290px",
                width: "100%",
                borderRadius: "36px",
                overflow: "hidden",
                boxShadow: isDark
                  ? "0 25px 60px rgba(0, 0, 0, 0.8), 0 0 40px rgba(3, 136, 214, 0.25)"
                  : "0 20px 50px rgba(0, 0, 0, 0.15), 0 0 30px rgba(3, 136, 214, 0.15)",
                border: isDark ? "4px solid rgba(255, 255, 255, 0.12)" : "4px solid rgba(0, 0, 0, 0.08)",
                transition: "transform 0.3s ease",
              }}
            >
              <img
                src={iphoneHero}
                alt="HubScroll Mobile App Preview"
                style={{
                  width: "100%",
                  height: "auto",
                  display: "block",
                }}
              />
            </div>

            {/* Floating Glassmorphic City Badge (clean without emojis) */}
            <div
              style={{
                position: "absolute",
                bottom: "30px",
                left: "10px",
                zIndex: 2,
                backgroundColor: isDark ? "rgba(15, 23, 42, 0.85)" : "rgba(255, 255, 255, 0.9)",
                backdropFilter: "blur(12px)",
                border: `1px solid ${colors.surfaceBorder}`,
                borderRadius: "1rem",
                padding: "0.75rem 1rem",
                boxShadow: "0 10px 25px rgba(0, 0, 0, 0.15)",
                display: "flex",
                alignItems: "center",
                gap: "0.6rem",
              }}
            >
              <div
                style={{
                  width: "8px",
                  height: "8px",
                  borderRadius: "50%",
                  backgroundColor: "#10b981",
                  boxShadow: "0 0 8px #10b981",
                }}
              />
              <div>
                <div style={{ fontSize: "0.82rem", fontWeight: 600, color: colors.textDark }}>
                  Dubai &middot; Abu Dhabi &middot; Sharjah
                </div>
                <div style={{ fontSize: "0.72rem", color: colors.textMuted }}>
                  4,500+ Handpicked Venues
                </div>
              </div>
            </div>

          </div>

        </div>
      </main>

      {/* 3. Admin View Floating Controls */}
      {isAdmin && (
        <aside
          aria-label="Admin controls"
          style={{
            position: "sticky",
            bottom: 0,
            zIndex: 100,
            background: "linear-gradient(90deg, #0f172a 0%, #1e293b 100%)",
            borderTop: "1px solid rgba(2, 132, 199, 0.3)",
            padding: "0.65rem 1.5rem",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            flexWrap: "wrap",
            gap: "0.75rem",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: "0.6rem" }}>
            <span style={{ width: "8px", height: "8px", borderRadius: "50%", backgroundColor: "#f59e0b", display: "inline-block" }} />
            <span style={{ color: "#FFFFFF", fontSize: "0.82rem", fontWeight: 500 }}>
              <strong>Admin Mode:</strong> Landing page is currently set to <em>Coming Soon (Maintenance)</em>.
            </span>
          </div>

          <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
            {onPreviewLive && (
              <button
                onClick={onPreviewLive}
                style={{
                  background: "rgba(255, 255, 255, 0.1)",
                  border: "1px solid rgba(255, 255, 255, 0.2)",
                  color: "#FFFFFF",
                  borderRadius: "9999px",
                  padding: "0.3rem 0.85rem",
                  fontSize: "0.78rem",
                  cursor: "pointer",
                  fontFamily: "'Outfit', sans-serif",
                }}
              >
                Preview Live Page &rarr;
              </button>
            )}
            {onSwitchToLive && (
              <button
                onClick={onSwitchToLive}
                style={{
                  background: "#10b981",
                  border: "none",
                  color: "#FFFFFF",
                  borderRadius: "9999px",
                  padding: "0.3rem 0.95rem",
                  fontSize: "0.78rem",
                  fontWeight: 600,
                  cursor: "pointer",
                  fontFamily: "'Outfit', sans-serif",
                }}
              >
                Switch to Live
              </button>
            )}
            <Link
              to="/control-tower"
              style={{
                background: "rgba(2, 132, 199, 0.25)",
                border: "1px solid rgba(2, 132, 199, 0.4)",
                color: "#38bdf8",
                borderRadius: "9999px",
                padding: "0.3rem 0.85rem",
                fontSize: "0.78rem",
                textDecoration: "none",
                fontFamily: "'Outfit', sans-serif",
                fontWeight: 500,
              }}
            >
              Control Tower &rarr;
            </Link>
          </div>
        </aside>
      )}

      {/* 4. Clean Footer */}
      <footer
        style={{
          borderTop: `1px solid ${colors.surfaceBorder}`,
          padding: "1.5rem",
          background: isDark ? "#060709" : "#FFFFFF",
        }}
      >
        <div
          style={{
            maxWidth: "1200px",
            margin: "0 auto",
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap",
            alignItems: "center",
            justifyContent: "space-between",
            gap: "1rem",
          }}
        >
          <div style={{ fontSize: "0.82rem", color: colors.textMuted, fontWeight: 300 }}>
            &copy; 2026 HubScroll &middot; Built for the UAE Hospitality Scene
          </div>
          <div style={{ display: "flex", gap: "1.5rem", fontSize: "0.82rem" }}>
            <Link to="/privacy-policy" style={{ color: colors.textMuted, textDecoration: "none" }}>Privacy Policy</Link>
            <Link to="/terms-and-conditions" style={{ color: colors.textMuted, textDecoration: "none" }}>Terms of Service</Link>
            <Link to="/contact" style={{ color: colors.textMuted, textDecoration: "none" }}>Contact Us</Link>
          </div>
        </div>
      </footer>
    </div>
  );
}
